module.exports = __webpack_public_path__ + "img/coin2.90b63cfa.png";